// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { berachainTestnetbArtio as _berachainTestnetbArtio } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the berachainTestnetbArtio chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 80084
 * Chain Name: Berachain bArtio
 * Default Block Explorer: https://bartio.beratrail.io
 * Default RPC URL: https://bartio.rpc.berachain.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { berachainTestnetbArtio } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: berachainTestnetbArtio,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const berachainTestnetbArtio = createCommon({
	..._berachainTestnetbArtio,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
